export default "__VITE_ASSET__BT8yU_FP__"